import { i as ionicCoreGlobalScript } from './ionic-global-a446a4db.js';

const globalScripts = () => {
  ionicCoreGlobalScript();
};

export { globalScripts as g };
